import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { connect } from 'react-redux'
import {
    createArticle,
    deleteArticle,
    fetchArticles,
    updateArticle,
} from '../../store/actions/articles'
import {
    createFaq,
    deleteFaq,
    fetchFaqs,
    updateFaq,
} from '../../store/actions/faqs'
import {
    addIconToAvailable,
    getAvailableIconList,
    removeIconFromAvailable,
} from '../../store/actions/icons'
import {
    addTagToAvailable,
    getAvailableTagsList,
    removeTagFromAvailable,
} from '../../store/actions/tags'
import { confirmationDialog } from '../common/confirmation-dialog'
import IconButton from '../common/icon-button'
import Loading from '../common/loading'
import { listUsers, deleteUser, makeUserModerator, makeUserNormal } from '../../store/actions/users'
import {
    fetchPregisteredEmails,
    pregisterEmail,
    unPregisterEmail,
    pregisterEmailList,
} from '../../store/actions/pre-register'
import { store } from '../../store/store'
import { showError } from '../../store/actions/alerts'
import { confirmAlert } from 'react-confirm-alert'
import TextAreaSubmit from '../common/text-area-submit'

export class ModeratorView extends React.Component {
    render() {
        return (
            <>
                <ul
                    className="nav nav-pills mb-3"
                    id="pills-tab"
                    role="tablist">
                    <li className="nav-item">
                        <a
                            className="nav-link active"
                            id="pills-tags-tab"
                            data-toggle="pill"
                            href="#pills-tags"
                            role="tab"
                            aria-controls="pills-tags"
                            aria-selected="true">
                            Tags
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link "
                            id="pills-icons-tab"
                            data-toggle="pill"
                            href="#pills-icons"
                            role="tab"
                            aria-controls="pills-icons"
                            aria-selected="false">
                            Icons
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            id="pills-articles-tab"
                            data-toggle="pill"
                            href="#pills-articles"
                            role="tab"
                            aria-controls="pills-articles"
                            aria-selected="false">
                            Articles
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            id="pills-faqs-tab"
                            data-toggle="pill"
                            href="#pills-faqs"
                            role="tab"
                            aria-controls="pills-faqs"
                            aria-selected="false">
                            Faqs
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            id="pills-users-tab"
                            data-toggle="pill"
                            href="#pills-users"
                            role="tab"
                            aria-controls="pills-users"
                            aria-selected="false">
                            Users
                        </a>
                    </li>
                </ul>

                <div className="tab-content" id="pills-tabContent">
                    <div
                        className="tab-pane fade show active"
                        id="pills-tags"
                        role="tabpanel"
                        aria-labelledby="pills-tags-tab">
                        <ConnectedTagsSubView />
                    </div>
                    <div
                        className="tab-pane fade "
                        id="pills-icons"
                        role="tabpanel"
                        aria-labelledby="pills-icons-tab">
                        <ConnectedIconsSubView />
                    </div>
                    <div
                        className="tab-pane fade"
                        id="pills-articles"
                        role="tabpanel"
                        aria-labelledby="pills-articles-tab">
                        <ConnectedArticlesSubView />
                    </div>
                    <div
                        className="tab-pane fade"
                        id="pills-faqs"
                        role="tabpanel"
                        aria-labelledby="pills-faqs-tab">
                        <ConnectedFaqsSubView />
                    </div>
                    <div
                        className="tab-pane fade"
                        id="pills-users"
                        role="tabpanel"
                        aria-labelledby="pills-users-tab">
                        <ConnectedUsersSubView />
                    </div>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    availableIconsList: state.icons.availableIconsList,
})

export default connect(mapStateToProps, { getAvailableIconList })(ModeratorView)

// Icons Sub View
// ----------------------------------

class IconsSubView extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            search: '',
        }
    }

    componentDidMount() {
        this.props.getAvailableIconList()
    }

    onPickIcon = (iconName) => {
        this.props.addIconToAvailable(iconName)
    }

    onUnpickIcon = (iconId) => {

        confirmationDialog({
            title: 'Delete Icon',
            text: 'Do you wish to delete the icon?',
            positiveText: 'Confirm',
            positiveColor: 'primary',
            negativeText: 'Cancel',
            negativeColor: 'secondary',

            positiveCallback: () => {
                this.props.removeIconFromAvailable(iconId)
            },
        })

        
    }

    onSearchIcon = (event) => {
        this.setState({
            search: event.target.value,
        })
    }

    render() {
        if (!this.props.icons.availableIconsList) return <Loading />

        const renderSelectedIconGrid = () => {
            return this.props.icons.availableIconsList.map((ic) => (
                <button
                    key={ic._id}
                    className="icon-select-button btn btn-white"
                    style={{
                        width: '80px',
                        height: '80px',
                        border: 'solid 1px #ced4da',
                    }}
                    onClick={() => {
                        this.onUnpickIcon(ic._id)
                    }}>
                    <h1 className="text-secondary text-center mb-0 ">
                        <FontAwesomeIcon icon={ic.name} />
                    </h1>
                </button>
            ))
        }

        const renderIconSelectionGrid = () => {
            const iconRepo = { ...fas }

            const showIconButtons = Object.keys(iconRepo)
                .filter(
                    (k) =>
                        iconRepo[k].iconName.includes(this.state.search) &&
                        !this.props.icons.availableIconsList.includes(
                            iconRepo[k].iconName
                        )
                )
                .map((k) => (
                    <button
                        key={iconRepo[k].iconName}
                        className="icon-select-button btn btn-white"
                        style={{
                            width: '60px',
                            height: '60px',
                            border: 'solid 1px #ced4da',
                        }}
                        onClick={() => {
                            this.onPickIcon(iconRepo[k].iconName)
                        }}>
                        <h4 className="text-secondary text-center mb-0 ">
                            <FontAwesomeIcon icon={iconRepo[k].iconName} />
                        </h4>
                    </button>
                ))

            return (
                <div className="">
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Search icons..."
                        value={this.state.search}
                        onChange={this.onSearchIcon}
                    />
                    <div className="container mt-2">{showIconButtons}</div>
                </div>
            )
        }

        return (
            <>
                <h4 className="text-primary mb-2">Available Icons</h4>
                <p>Click on the icons to remove them.</p>
                {!this.props.icons ||
                this.props.icons.availableIconsList.length === 0 ? (
                    <p>No icons available...</p>
                ) : (
                    <div className="container">{renderSelectedIconGrid()}</div>
                )}

                <h4 className="text-primary mt-4 mb-2">Add More Icons</h4>
                <p>Click on the icons to add them.</p>

                <div className="">{renderIconSelectionGrid()}</div>
            </>
        )
    }
}

const ConnectedIconsSubView = connect(
    (state) => ({
        auth: state.auth,
        icons: state.icons,
    }),
    {
        getAvailableIconList,
        addIconToAvailable,
        removeIconFromAvailable,
    }
)(IconsSubView)

// Tags Sub View
// ----------------------------------

class TagsSubView extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            addTag: '',
        }
    }

    componentDidMount() {
        this.props.getAvailableTagsList()
    }

    onAddTag = () => {
        this.props.addTagToAvailable(this.state.addTag)
    }

    onRemoveTag = (tagId) => {

        confirmationDialog({
            title: 'Delete Tag',
            text: 'Do you wish to delete the tag?',
            positiveText: 'Confirm',
            positiveColor: 'primary',
            negativeText: 'Cancel',
            negativeColor: 'secondary',

            positiveCallback: () => {
                this.props.removeTagFromAvailable(tagId)
            },
        })


        
    }

    onWriteTag = (event) => {
        this.setState({
            addTag: event.target.value,
        })
    }

    render() {
        if (!this.props.tags) return <Loading />

        const renderAvailableTags = () => {
            return this.props.tags.map((tag) => (
                <button
                    key={tag._id}
                    className="icon-select-button btn btn-white mx-2 my-1"
                    onClick={() => {
                        this.onRemoveTag(tag._id)
                    }}>
                    <h6 className="text-secondary text-center mb-0 ">
                        {tag.name}
                    </h6>
                </button>
            ))
        }

        return (
            <>
                <h4 className="text-primary mb-2">Available Tags</h4>
                <p>Click on the tags to remove them.</p>
                {!this.props.tags || this.props.tags.length === 0 ? (
                    <p>No tags available...</p>
                ) : (
                    <div className="container">{renderAvailableTags()}</div>
                )}

                <h4 className="text-primary mt-4 mb-2">Add More Tags</h4>

                <input
                    type="text"
                    className="form-control mb-2"
                    style={{ width: '200px' }}
                    placeholder="Tag Name"
                    value={this.state.addTag}
                    onChange={this.onWriteTag}
                />
                <button className="btn btn-primary" onClick={this.onAddTag}>
                    Add Tag
                </button>
            </>
        )
    }
}

const ConnectedTagsSubView = connect(
    (state) => ({
        auth: state.auth,
        tags: state.tags.availableTagsList,
    }),
    {
        getAvailableTagsList,
        addTagToAvailable,
        removeTagFromAvailable,
    }
)(TagsSubView)

// Articles Sub View
// ----------------------------------

class ArticlesSubView extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            article: undefined,
            editingArticle: false,
        }
    }

    componentDidMount() {
        this.props.fetchArticles()
    }

    componentDidUpdate(prevProps) {
        if (this.props.articles !== prevProps.articles) {
            this.setState({ editingArticle: false })
        }
    }

    onDeleteArticle = (article_id) => {
        confirmationDialog({
            title: 'Delete Article',
            text: 'Do you wish to delete the article?',
            positiveText: 'Submit',
            positiveColor: 'primary',
            negativeText: 'Cancel',
            negativeColor: 'secondary',

            positiveCallback: () => {
                this.props.deleteArticle(article_id)
            },
        })
    }

    onSetArticleProperty = (propertyName, value) => {
        this.setState((prevState) => ({
            article: {
                ...prevState.article,
                [propertyName]: value,
            },
        }))
    }

    startEditingArticle = (article) => {
        if (!article) {
            this.setState({
                article: {
                    title: '',
                    description: '',
                    image_url: '',
                    url: '',
                    button_text: '',
                },
                editingArticle: true,
            })
        } else {
            this.setState({
                article: article,
                editingArticle: true,
            })
        }
    }

    render() {
        if (!this.props.articles) return <Loading />

        const renderArticleEdit = () => {
            return (
                <div className="border p-4">
                    <h4 className="text-primary mb-4">
                        {this.state.article._id
                            ? 'Edit Article'
                            : 'New Article'}
                    </h4>

                    <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="Title"
                        value={this.state.article.title}
                        onChange={(e) =>
                            this.onSetArticleProperty('title', e.target.value)
                        }
                    />

                    <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="Description"
                        value={this.state.article.description}
                        onChange={(e) =>
                            this.onSetArticleProperty(
                                'description',
                                e.target.value
                            )
                        }
                    />

                    <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="Image URL"
                        value={this.state.article.image_url}
                        onChange={(e) =>
                            this.onSetArticleProperty(
                                'image_url',
                                e.target.value
                            )
                        }
                    />

                    <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="Article URL"
                        value={this.state.article.url}
                        onChange={(e) =>
                            this.onSetArticleProperty('url', e.target.value)
                        }
                    />
                    <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="Button Text"
                        value={this.state.article.button_text}
                        onChange={(e) =>
                            this.onSetArticleProperty(
                                'button_text',
                                e.target.value
                            )
                        }
                    />

                    <button
                        className="btn btn-primary mt-2 mb-2"
                        onClick={() => {
                            this.state.article._id
                                ? this.props.updateArticle(
                                      this.state.article._id,
                                      this.state.article
                                  )
                                : this.props.createArticle(this.state.article)
                        }}>
                        Submit
                    </button>
                </div>
            )
        }

        return (
            <>
                <h4 className="text-primary mb-2">Available Articles</h4>

                {!this.props.articles || this.props.articles.length === 0 ? (
                    <p>No articles available...</p>
                ) : (
                    <div className="container">
                        {this.props.articles.map((article) => (
                            <div
                                key={article._id}
                                className="contianer row mb-2 mt-2"
                                style={{
                                    borderBottom: '1px',
                                    borderBottomStyle: 'dashed',
                                }}>
                                <div className="col-sm-10">{article.title}</div>
                                <div className="col-sm-1">
                                    <IconButton
                                        icon="edit"
                                        onClick={() =>
                                            this.startEditingArticle(article)
                                        }
                                    />
                                </div>
                                <div className="col-sm-1">
                                    <IconButton
                                        icon="trash"
                                        onClick={() =>
                                            this.onDeleteArticle(article._id)
                                        }
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                <button
                    className="btn btn-primary mt-4 mb-2"
                    onClick={() => this.startEditingArticle()}>
                    Add Article
                </button>

                {this.state.editingArticle && renderArticleEdit()}
            </>
        )
    }
}

const ConnectedArticlesSubView = connect(
    (state) => ({
        auth: state.auth,
        articles: state.articles.articleList,
    }),
    {
        fetchArticles,
        createArticle,
        deleteArticle,
        updateArticle,
    }
)(ArticlesSubView)

// Faqs Sub View
// ----------------------------------

class FaqsSubView extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            faq: undefined,
            editingFaq: false,
        }
    }

    componentDidMount() {
        this.props.fetchFaqs()
    }

    componentDidUpdate(prevProps) {
        if (this.props.faqs !== prevProps.faqs) {
            this.setState({ editingFaq: false })
        }
    }

    onDeleteFaq = (faq_id) => {
        confirmationDialog({
            title: 'Delete FAQ',
            text: 'Do you wish to delete the FAQ?',
            positiveText: 'Confirm',
            positiveColor: 'primary',
            negativeText: 'Cancel',
            negativeColor: 'secondary',

            positiveCallback: () => {
                this.props.deleteFaq(faq_id)
            },
        })
    }

    onSetFaqProperty = (propertyName, value) => {
        this.setState((prevState) => ({
            faq: {
                ...prevState.faq,
                [propertyName]: value,
            },
        }))
    }

    startEditingFaq = (faq) => {
        if (!faq) {
            this.setState({
                faq: {
                    question: '',
                    answer: '',
                },
                editingFaq: true,
            })
        } else {
            this.setState({
                faq: faq,
                editingFaq: true,
            })
        }
    }

    render() {
        if (!this.props.faqs) return <Loading />

        const renderFaqEdit = () => {
            return (
                <div className="border p-4">
                    <h4 className="text-primary mb-4">
                        {this.state.faq._id ? 'Edit FAQ' : 'New FAQ'}
                    </h4>

                    <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="Question"
                        value={this.state.faq.question}
                        onChange={(e) =>
                            this.onSetFaqProperty('question', e.target.value)
                        }
                    />
                    <input
                        className="form-control mb-2"
                        type="text"
                        placeholder="Answer"
                        value={this.state.faq.answer}
                        onChange={(e) =>
                            this.onSetFaqProperty('answer', e.target.value)
                        }
                    />

                    <button
                        className="btn btn-primary mt-2 mb-2"
                        onClick={() => {
                            this.state.faq._id
                                ? this.props.updateFaq(
                                      this.state.faq._id,
                                      this.state.faq.question,
                                      this.state.faq.answer
                                  )
                                : this.props.createFaq(
                                      this.state.faq.question,
                                      this.state.faq.answer
                                  )
                        }}>
                        Submit
                    </button>
                </div>
            )
        }

        return (
            <>
                <h4 className="text-primary mb-2">Available FAQs</h4>

                {!this.props.faqs || this.props.faqs.length === 0 ? (
                    <p>No faqs available...</p>
                ) : (
                    <div className="container">
                        {this.props.faqs.map((faq) => (
                            <div
                                key={faq._id}
                                className="contianer row mb-2 mt-2"
                                style={{
                                    borderBottom: '1px',
                                    borderBottomStyle: 'dashed',
                                }}>
                                <div className="col-sm-10">
                                    <div className="row text-primary mt-1">
                                        Q: {faq.question}
                                    </div>
                                    <div className="row">A: {faq.answer}</div>
                                </div>

                                <div className="col-sm-1">
                                    <IconButton
                                        icon="edit"
                                        onClick={() =>
                                            this.startEditingFaq(faq)
                                        }
                                    />
                                </div>
                                <div className="col-sm-1">
                                    <IconButton
                                        icon="trash"
                                        onClick={() =>
                                            this.onDeleteFaq(faq._id)
                                        }
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                <button
                    className="btn btn-primary mt-4 mb-2"
                    onClick={() => this.startEditingFaq()}>
                    Add FAQ
                </button>

                {this.state.editingFaq && renderFaqEdit()}
            </>
        )
    }
}

const ConnectedFaqsSubView = connect(
    (state) => ({
        auth: state.auth,
        faqs: state.faqs.faqsList,
    }),
    {
        fetchFaqs,
        createFaq,
        deleteFaq,
        updateFaq,
    }
)(FaqsSubView)

// Users Sub View
// ----------------------------------

class UsersSubView extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            emailsToRegister: '',
        }
    }

    componentDidMount() {
        this.props.listUsers()
        this.props.fetchPregisteredEmails()
    }

    componentDidUpdate(prevProps) {
        if (this.props.registeredUsers !== prevProps.registeredUsers) {
            console.log("Updated")
        } else {
            console.log("not updated")
        }
    }

    isValidEmail(email) {
        var re = /\S+@\S+\.\S+/
        return re.test(email)
    }

    onUnpregisterEmail = (email) => {
        confirmationDialog({
            title: 'Remove Email',
            text:
                'Removing this email will prevent the user from registering an account, but will not prevent a user with an existing account from logging in. If you wish to prevent the user from logging in, please also remove the user. Proceed?',
            positiveText: 'Proceed',
            positiveColor: 'primary',
            negativeText: 'Cancel',
            negativeColor: 'secondary',

            positiveCallback: () => {
                this.props.unPregisterEmail(email)
            },
        })
    }

    onDeleteUser = (user_id) => {
        confirmationDialog({
            title: 'Remove User',
            text:
                "Removing the user will delete the account, but won't prevent the user from registering again. If you wish to prevent the user from registering again, please also unregister the email. Proceed?",
            positiveText: 'Proceed',
            positiveColor: 'primary',
            negativeText: 'Cancel',
            negativeColor: 'secondary',

            positiveCallback: () => {
                this.props.deleteUser(user_id)
            },
        })
    }

    validateEmails = (input) => {
        const emails = input
            .trim()
            .split(/\r\n|\r|\n|,| |\t/g)
            // .split(',')
            .map((m) => m.trim())
            .filter((e) => e.length > 4)

        if (emails.length === 0) {
            store.dispatch(
                showError(
                    `Please add emails separated by commas or line breaks.`
                )
            )
            return
        }

        const validations = emails
            .filter((e) => e.length > 4)
            .map((e) => ({ email: e, isValid: this.isValidEmail(e) }))
            .filter((v) => !v.isValid)

        if (validations.length > 0) {
            store.dispatch(
                showError(`Invalid email address: ${validations[0].email}`)
            )
            return false
        }

        return emails
    }

    onRegisterEmails = (emails) => {
        this.props.pregisterEmailList(emails)
    }

    onRegisterEmailsClick = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="border p-4" style={{ width: '600px' }}>
                        <h4 className="text-primary mb-4">Register Emails</h4>
                        <p>
                            Insert the emails to register separated by comma (,)
                            or one in each line.
                        </p>

                        <TextAreaSubmit
                            onSubmit={(input) => {
                                const emails = this.validateEmails(input)

                                if (emails) {
                                    this.props.pregisterEmailList(emails)
                                    onClose()
                                }
                            }}
                            rows={20}
                            hideLength={true}></TextAreaSubmit>
                    </div>
                )
            },
        })
    }

    onMakeUserModerator = (user_id) => {

        confirmationDialog({
            title: 'Make Moderator',
            text: "This will grant this user Moderator previleges. Proceed?",
            positiveText: 'Proceed',
            positiveColor: 'primary',
            negativeText: 'Cancel',
            negativeColor: 'secondary',

            positiveCallback: () => {
                this.props.makeUserModerator(user_id)
                // this.props.deleteUser(user_id)
            },
        })

       
    }
    
    onMakeUserNormal = (user_id) => {

        confirmationDialog({
            title: 'Make Moderator',
            text: "This will remove all previleges from this user. Proceed?",
            positiveText: 'Proceed',
            positiveColor: 'primary',
            negativeText: 'Cancel',
            negativeColor: 'secondary',

            positiveCallback: () => {
                this.props.makeUserNormal(user_id)
            },
        })        
    }



    render() {
        if (!this.props.pregisteredEmails || !this.props.registeredUsers)
            return <Loading />

        return (
            <>
                <h4 className="text-primary mb-2">Pre-Registered Emails</h4>

                <button
                    className="btn btn-primary mt-4 mb-2"
                    onClick={() => this.onRegisterEmailsClick()}>
                    Pre-Register Emails
                </button>

                <p className="text-secondayr mb-2">
                    Only email addresses registered via this page will be able o
                    join Idea-Box.
                </p>

                <div
                    style={{
                        overflow: 'auto',
                        minHeight: '300px',
                        maxHeight: '600px',
                    }}>
                    <table className="table">
                        <tbody>
                            {this.props.pregisteredEmails.map((e) => (
                                <tr key={e}>
                                    <td>{e}</td>
                                    <td>
                                        <IconButton
                                            icon="trash"
                                            onClick={() =>
                                                this.onUnpregisterEmail(e)
                                            }
                                        />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>


                <h4 className="text-primary mt-4 mb-2">Registered Users</h4>
                <p className="text-secondayr mb-2">
                    Users who've registered in Idea-Box.
                </p>

                <div style={{ overflow: 'auto', height: '300px' }}>
                    <table className="table">
                        <tbody>
                            {this.props.registeredUsers.map((u) => (
                                <tr key={u.email}>
                                    <td>
                                        {u.firstName} {u.lastName} ({u.email})
                                    </td>

                                    <td className="ml-2">
                                    {u.email !== 'admin@idea-box.com' && // u.email !== this.props.auth.user.email && 
                                        <IconButton
                                            icon="key"
                                            pressed={u.type === "moderator" ? "true" : undefined}
                                            onClick={() =>
                                                u.type === "moderator" ?
                                                this.onMakeUserNormal(u._id) :
                                                this.onMakeUserModerator(u._id)
                                            }
                                        />
                                    }
                                    </td>
                                    <td className="ml-2">
                                    {u.email !== 'admin@idea-box.com' && u.email !== this.props.auth.user.email && 
                                        <IconButton
                                            icon="trash"
                                            onClick={() =>
                                                this.onDeleteUser(u._id)
                                            }
                                        />
                                    }
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </>
        )
    }
}

const ConnectedUsersSubView = connect(
    (state) => ({
        auth: state.auth,
        pregisteredEmails: state.preregister.emailList,
        registeredUsers: state.users.userList,
    }),
    {
        listUsers,
        deleteUser,
        fetchPregisteredEmails,
        pregisterEmail,
        pregisterEmailList,
        unPregisterEmail,
        makeUserModerator,
        makeUserNormal
    }
)(UsersSubView)
